import React from 'react';
import { Link } from 'react-router-dom';

import { SiteConfigManager } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { Button } from '@atlas/ui';

import NotificationStatePopup from 'common/Popup/NotificationStatePopup';

const { CASINO, SPORT_PREMATCH } = COMPONENT_TYPES;

const NotFound = () => {
  const sportRoute = SiteConfigManager.getComponentPath(SPORT_PREMATCH);
  const casinoRoute = SiteConfigManager.getComponentPath(CASINO);

  const pages = SiteConfigManager.getConfig('config.pages');

  const isSportsbookActive = pages.some(page => page.path === sportRoute && page.isActive);
  const isCasinoActive = pages.some(page => page.path === casinoRoute && page.isActive);

  return (
    <NotificationStatePopup
      className="not-found-page"
      header={<h3 className="not-found-page__header">404</h3>}
      isNotFound
      message="The page you are looking for may have been deleted"
      title="Page not found"
    >
      <div className="sticky-bottom-buttons-container double without-padding-bg">
        {isSportsbookActive && (
          <Link className="primary" to={sportRoute}>
            <Button label="go_to_sport" size="big" type="primary" />
          </Link>
        )}
        {isCasinoActive && (
          <Link className="primary" to={casinoRoute}>
            <Button label="go_to_casino" size="big" type="primary" />
          </Link>
        )}
      </div>
    </NotificationStatePopup>
  );
};
export default NotFound;
